import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef, useState, useMemo } from "react";
import { Dimensions } from "react-native";
import { getBreakpointIndex } from "./get-breakpoint-index";
import { useDripsyTheme } from "../use-dripsy-theme";
import { BreakpointIndexContext } from "./breakpoint-context";
export var useBreakpoints = function() {
    var _dripsy_theme;
    var dripsy = useDripsyTheme();
    var breakpoints = dripsy === null || dripsy === void 0 ? void 0 : (_dripsy_theme = dripsy.theme) === null || _dripsy_theme === void 0 ? void 0 : _dripsy_theme.breakpoints;
    if (breakpoints && typeof __DEV__ !== "undefined" && __DEV__) {
        if (!Array.isArray(breakpoints)) {
            var arrayError = "[dripsy] theme.breakpoints must be an array. Or, you can leave it blank. However, you used \n" + JSON.stringify(breakpoints) + '\n Please turn this into an array, or remove the "breakpoints" field from your theme.';
            throw new Error(arrayError);
        }
    }
    return useMemo(function() {
        return (breakpoints || defaultBreakpoints).map(function(breakpoint) {
            if (typeof breakpoint === "string") {
                if (breakpoint.endsWith("px")) {
                    return Number(breakpoint.replace("px", ""));
                }
            }
            if (typeof breakpoint !== "number") {
                console.error('[dripsy] Invalid breakpoints passed to theme.breakpoints. Expected an array of numbers, or strings ending with "px", but got this: \n', JSON.stringify(breakpoints), "\nPlease turn these into numbers, or remove the breakpoints array from your theme.");
            }
            return Number(breakpoint);
        });
    }, [
        breakpoints
    ]);
};
export var defaultBreakpoints = [
    576,
    768,
    992,
    1200
];
var useCreateBreakpointIndex = function() {
    var breakpoints = useBreakpoints();
    var _useState = _sliced_to_array(useState(function() {
        return getBreakpointIndex({
            width: Dimensions.get("window").width,
            breakpoints: breakpoints
        });
    }), 2), index = _useState[0], setIndex = _useState[1];
    var indexRef = useRef(index);
    useEffect(function() {
        indexRef.current = index;
    }, [
        index
    ]);
    useEffect(function() {
        var onChange = function(param) {
            var width = param.window.width;
            var breakpointIndex = getBreakpointIndex({
                width: width,
                breakpoints: breakpoints
            });
            if (breakpointIndex !== indexRef.current) {
                setIndex(breakpointIndex);
            }
        };
        var unsubscribe = Dimensions.addEventListener("change", onChange);
        onChange({
            window: Dimensions.get("window"),
            screen: Dimensions.get("screen")
        });
        return function() {
            if (!(unsubscribe === null || unsubscribe === void 0 ? void 0 : unsubscribe.remove)) {
                // @ts-ignore
                Dimensions.removeEventListener("change", onChange);
            } else {
                unsubscribe.remove();
            }
        };
    }, [
        breakpoints
    ]);
    return index;
};
export function BreakpointIndexProvider(param) {
    var children = param.children;
    var breakpointIndex = useCreateBreakpointIndex();
    return /*#__PURE__*/ _jsx(BreakpointIndexContext.Provider, {
        value: breakpointIndex,
        children: children
    });
}
